import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {useAbility} from '@casl/react';

import {Menu} from 'antd';
import routesConfig from 'pages/routeConfig';
import {useSidebarContext} from './AppContextProvider/SidebarContextProvider';
import {AbilityContext} from 'configs/CASLContext';
import {isPermit} from 'utils/AuthUtils';

function getStyles(item, sidebarColorSet, isSidebarBgImage, index, isGroup) {
  const {pathname} = useLocation();
  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/');

  if (index === 0 || isGroup) {
    return {
      color: sidebarColorSet.sidebarTextColor,
      backgroundColor: isSidebarBgImage ? '' : sidebarColorSet.sidebarBgColor,
    };
  } else {
    const isActive = defaultOpenKeys[index] === item.id;

    return {
      color: isActive
        ? sidebarColorSet.sidebarMenuSelectedTextColor
        : sidebarColorSet.sidebarTextColor,
      backgroundColor: isActive
        ? sidebarColorSet.sidebarMenuSelectedBgColor
        : isSidebarBgImage
        ? ''
        : sidebarColorSet.sidebarBgColor,
    };
  }
}

const renderMenuItemChildren = (ability, item) => {
  const {icon, messageId, path} = item;
  const {messages} = useIntl();

  if (isPermit(ability, item.authorities)) {
    if (path && path.includes('/'))
      return (
        <Link to={path}>
          {icon &&
            (React.isValidElement(icon) ? (
              <span className='ant-menu-item-icon'>{icon}</span>
            ) : (
              <icon className='ant-menu-item-icon' />
            ))}
          <span data-testid={messageId.toLowerCase + '-nav'}>
            {messages[messageId]}
          </span>
        </Link>
      );
    else {
      return (
        <>
          {icon &&
            (React.isValidElement(icon) ? (
              <span className='ant-menu-item-icon'>{icon}</span>
            ) : (
              <icon className='ant-menu-item-icon' />
            ))}
          <span data-testid={messageId.toLowerCase + '-nav'}>
            {messages[messageId]}
          </span>
        </>
      );
    }
  }
};

const renderMenuItem = (
  ability,
  item,
  sidebarColorSet,
  isSidebarBgImage,
  index,
) => {
  return (
    isPermit(ability, item.authorities) &&
    (item.type === 'collapse' ? (
      <Menu.SubMenu
        style={getStyles(item, sidebarColorSet, isSidebarBgImage, index, true)}
        key={item.path ? item.path : item.id}
        title={renderMenuItemChildren(
          ability,
          item,
          sidebarColorSet,
          isSidebarBgImage,
        )}>
        {item.children.map((item) =>
          renderMenuItem(
            ability,
            item,
            sidebarColorSet,
            isSidebarBgImage,
            index + 1,
          ),
        )}
      </Menu.SubMenu>
    ) : (
      <Menu.Item
        key={item.id}
        style={getStyles(item, sidebarColorSet, isSidebarBgImage, index)}>
        {item.children
          ? item.children
          : renderMenuItemChildren(
              ability,
              item,
              sidebarColorSet,
              isSidebarBgImage,
            )}
      </Menu.Item>
    ))
  );
};

const renderMenu = (
  ability,
  item,
  sidebarColorSet,
  isSidebarBgImage,
  index,
) => {
  return (
    isPermit(ability, item.authorities) &&
    (item.type === 'group' ? (
      <Menu.ItemGroup
        style={getStyles(item, sidebarColorSet, isSidebarBgImage, index, true)}
        key={item.path ? item.path : item.id}
        title={renderMenuItemChildren(
          ability,
          item,
          sidebarColorSet,
          isSidebarBgImage,
        )}>
        {item.children.map((item) =>
          renderMenuItem(
            ability,
            item,
            sidebarColorSet,
            isSidebarBgImage,
            index + 1,
          ),
        )}
      </Menu.ItemGroup>
    ) : (
      <Menu.Item
        key={item.id}
        exact={item.exact}
        style={getStyles(item, sidebarColorSet, isSidebarBgImage, index)}>
        {item.children
          ? item.children
          : renderMenuItemChildren(
              ability,
              item,
              sidebarColorSet,
              isSidebarBgImage,
              index,
            )}
      </Menu.Item>
    ))
  );
};

export const getRouteMenus = () => {
  const {sidebarColorSet} = useSidebarContext();
  const {isSidebarBgImage} = useSidebarContext();
  const ability = useAbility(AbilityContext);

  return routesConfig.map((route) =>
    renderMenu(ability, route, sidebarColorSet, isSidebarBgImage, 0),
  );
};
